import * as React from "react";
const SvgEdit24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 23,
        fill: "black",
        viewBox: "0 0 23 23"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16.507 1.693 15.8.986l-.707.707-13.8 13.8-.248.248-.039.349-.6 5.4-.138 1.242 1.242-.138 5.4-.6.349-.039.248-.248 13.8-13.8.707-.707-.707-.707-4.8-4.8ZM2.532 20.468l.423-3.809L12.5 7.114l.193.193 3 3 .193.193-9.545 9.545-3.81.423ZM17.3 9.086 19.186 7.2 15.8 3.814 13.914 5.7l.193.193 3 3 .193.193Z",
      clipRule: "evenodd"
    })
  );
export default SvgEdit24Px;
